// Establishes a query container so the grid responds to the available content
// width, not the viewport width (the sidebar narrows the space on desktop).
// The width cap itself (issue #4553) now lives on the layout's main column, so
// the banners above the content share it too — see inMainLayout/styles.module.scss.
.homeGridContainer {
	container: homeGrid / inline-size;
}

.homeGrid {
	@apply yst-grid yst-gap-6 yst-items-stretch;
	grid-template-columns: 1fr;
}

// Switch to a 2-column grid once the container itself is wide enough,
// regardless of viewport width.
@container homeGrid (min-width: 768px) {
	.homeGrid {
		grid-template-columns: repeat(2, 1fr);
	}
}

// Make each card fill the full row height (equal-height cards).
.cardWrapper {
	@apply yst-flex yst-flex-col yst-h-full;
}

.cardWrapper > * {
	@apply yst-flex-1;
}

:global {
	.AiBrandInsightsCard {
		.ai-insights-app {
			height: 100%;

			.yst-root, .yst-card {
				height: 100%;
			}
		}
	}
}
